import { NOTIF_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const addNotif = notif => {
  return myFetch(`${NOTIF_ENDPOINT}`, "POST", notif);
};
